<template>
    <activation-brief-orders-list-provider
        v-slot="{ brief, isLoading, orders, numberOfPages, currentPage, loadOrdersPage }"
        style="height: 100%"
    >
        <activation-brief-orders-list-view
            v-if="brief"
            :brief="brief"
            :orders="orders"
            :number-of-pages="numberOfPages"
            :current-page="currentPage"
            :is-loading="isLoading"
            :load-orders-page="loadOrdersPage"
        />
    </activation-brief-orders-list-provider>
</template>

<script>
    import ActivationBriefOrdersListView from '../data-views/activation-briefs/partials/orders/ActivationBriefOrdersListView';
    import ActivationBriefOrdersListProvider from '../providers/activation-brief-steps/ActivationBriefOrdersListProvider';

    export default {
        name: 'ActivationBriefOrdersListRouterView',
        components: {
            ActivationBriefOrdersListProvider,
            ActivationBriefOrdersListView
        }
    };
</script>
